@if (dateTime()) {
    <span [tooltipDisabled]="showTooltip()" [pTooltip]="dateTime()?.time ?? ''" [tooltipPosition]="'top'">
        {{ dateOnly() ? dateOnlyIndicator() : (dateTime()?.date ?? '-') }}
        @if (showTime()) {
            {{ '@' }} {{ dateTime()?.time ?? '-' }}
        }
    </span>
} @else {
    -
}
